import React from 'react';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { Button } from 'reactstrap';
import { generateResponseData } from './simpleFunctions';
import dataObject from './data';


const Prop = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

const PropAnswers = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  answers: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

const getQuestionsFromData = (data) => {
  // empty array of questions to go in
  const questionList = [];
  // map data into the item layer which contains all the groups and questions
  const dataItem = data.item;
  // loop through all the data items (groups/questions)
  dataItem.forEach((element) => {
    if (element.type === 'group') {
      // data inside the group layers which contains all the questions only
      const groupItem = element.item;
      // loop through all the data groups (questions only)
      groupItem.forEach((item) => {
        // get the question ID in the below format
        const id = element.linkId + item.linkId;
        // this data is now the question layer and question is set to be the question text
        const question = item.text;
        // adds the group ID for each question
        // const parentId = element.linkId;
        // push the question onto the questionList
        questionList.push({ id, question });
      });
    }
  });
  return questionList;
};

// logic to check if the question id exists for an answer (merged array)
const combineQuestionsAndAnswer = (questions, answers, data, patient) => {
  // TODO - investigate and possibly rewrite function to delete 'return null'
  answers.map((answer) => {
    const groupId = answer.id.slice(0, 1);
    const questionId = answer.id.slice(1);
    let responseData = generateResponseData(dataObject, false, {}, {}, 'DTT');
    if (patient) {
      responseData = generateResponseData(data, false, {}, {}, 'DTT');
    }

    responseData.item
      .find(item => item.linkId === groupId)
      .item.find(item => item.linkId === questionId).answer[0].valueString =
      answer.answers[0];
      return null;
  });

  const merged = questions.map((element) => {
    // filter answers array so only they exist if question id (element.id) has an answer id
    const filtered = answers.filter(item => item.id === element.id);
    // condition for array if it doesn't have an answer ie it didn't pop up (enabled)
    if (filtered.length <= 0) {
      return [element.question, ['Not Answered']];
    }
    return [element.question, filtered[0].answers || ['Not Answered']];
  });
  return merged;
};

export const DownloadCSVComponent = ({ patient, data, answers }) => {
  const allQuestions = getQuestionsFromData(data);
  //  merged combined component to sort through answers and questions
  const csvData = combineQuestionsAndAnswer(allQuestions, answers, data, patient);
  return (
    <CSVLink
      data={csvData}
      filename={answers[0] ? `${answers[0].answers}-DTT.csv` : 'blank.csv'}
    >
      <Button
        color="success"
        disabled={!answers[0]}
        className="question-button"
      >
        {patient === false ?
          <div>Download Clinician Answers as CSV</div>
          :
          <div>Download Patient Answers as CSV</div>
        }

      </Button>
    </CSVLink>
  );
};

// Proptypes
DownloadCSVComponent.propTypes = PropAnswers;
getQuestionsFromData.propTypes = Prop;

// const DownloadCSV = connect(mapStateToProps)(DownloadCSVComponent);

// export default DownloadCSV;
export { getQuestionsFromData, combineQuestionsAndAnswer };



// WEBPACK FOOTER //
// ./src/components/DownloadCSV.js